import localeDateInputOrder from '@/helpers/locale-date-input-order';



/**
 * Parse the slash-separated string from the birthday input into the
 * structured `{ day, month, year }` shape the BE expects. The order is
 * interpreted using the device locale — en-GB / en-AU treat the first
 * segment as the day, everyone else as the month.
 *
 * Both two-segment ("MM/DD" or "DD/MM") and three-segment forms are
 * supported. Returns numeric values; `year` is omitted when not present.
 *
 * @param {string} value
 * @returns {{ day: number, month: number, year?: number }}
 */
function parseBirthdayFromInput(value) {
  const parts = value.split('/');
  const order = localeDateInputOrder();

  let dayStr;
  let monthStr;
  let yearStr;

  if (order === 'DMY') {
    [dayStr, monthStr, yearStr] = parts;
  }
  else {
    [monthStr, dayStr, yearStr] = parts;
  }

  return {
    day: Number(dayStr),
    month: Number(monthStr),
    ...(yearStr && { year: Number(yearStr) })
  };
}



export default parseBirthdayFromInput;
